define.alias("shared/errors/api-authorization-error", "settings/errors/api-authorization-error");